var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserPlaceholder = function SvgUserPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "userPlaceholder_svg__a",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    id: "userPlaceholder_svg__c",
    d: "M19.125 20.4v-2.55c.572-.284 2.216-2.236 2.386-3.765.453-.035 1.16-.449 1.369-2.082.115-.881-.333-1.375-.602-1.529 0 0 .672-1.28.672-2.824 0-3.093-1.215-5.738-3.825-5.738 0 0-.907-1.912-3.825-1.912-5.409 0-7.65 3.472-7.65 7.65 0 1.409.672 2.824.672 2.824-.27.154-.717.653-.602 1.529.21 1.633.916 2.047 1.37 2.082.17 1.529 1.813 3.48 2.385 3.765v2.55C10.2 24.225 0 21.675 0 30.6h30.6c0-8.925-10.2-6.375-11.475-10.2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "userPlaceholder_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#userPlaceholder_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#userPlaceholder_svg__a",
    fill: "#DDD"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#userPlaceholder_svg__b)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#userPlaceholder_svg__c",
    fill: "#9B9B9B",
    transform: "translate(4.7 9.4)"
  })))));
};
export { SvgUserPlaceholder as ReactComponent };
export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvbWVkaWEvdXNlclBsYWNlaG9sZGVyLjEzMmUwNGEzLnN2ZyI7";